import React from 'react';
import logo from '../assets/salesyo-logo.png';

function Footer() {
  return (
    <footer>
      <div className="wrap foot-in">
        <img className="foot-logo" src={logo} alt="Salesyo" />
        <div>© 2026 Salesyo · AI sales operator · GDPR compliant · Hosted in the EU</div>
      </div>
      <p className="disc">
        Market statistics from public sources (Harvard Business Review, MIT/InsideSales, Baromètre du Lead 2025).
        Calculator estimates are indicative and depend on your actual business. Meta Business Partner status,
        EU hosting and GDPR compliance to be confirmed as effective before broad communication.
      </p>
    </footer>
  );
}

export default Footer;
